export enum ChartTypes {
    BUBBLE = 'packedbubble'
}
